import {
  FormControl,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Paper,
} from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import TableUsers from "../components/TableUsers";
import api from "../services/api";
import SearchIcon from "@mui/icons-material/Search";
import auth from "../services/auth";
//import AddIcon from "@mui/icons-material/Add";

export default function Users() {
  const [error, setError] = useState(null);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingButton, setLoadingButton] = useState({ loading: false, id: 0 });
  const [search, setSearch] = useState("");

  useEffect(() => {
    const params = search ? { search: search } : {};
    setLoading(true);
    api
      .get("users?page=1", { params, headers: auth.token() })
      .then((response) => {
        setLoading(false);
        if (response.status === 200) {
          if (response.data.data) {
            setUsers(response.data.data);
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        setError(error);
      });
    return () => {
      setUsers([]);
      setError(null);
      setLoading(false);
    };
  }, [search]);

  const onSearch = (value) => {
    setSearch(value);
  };

  const handleStatus = (id, status) => {
    var i;
    const newStatus =
      status === "active"
        ? "inactive"
        : status === "inactive"
        ? "active"
        : "inactive";

    setLoadingButton({ loading: true, id });

    api
      .patch(`users/${id}`, { status: newStatus }, { headers: auth.token() })
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          setLoadingButton({ loading: false, id });
          for (i = 0; i < users.length; i++) {
            if (users[i].id === id) {
              users[i].status =
                users[i].status === "acitive"
                  ? "inactive"
                  : users[i].status === "inactive"
                  ? "acitive"
                  : "inactive";
              setUsers([...users]);
            }
          }
        }
      })
      .catch((err) => {
        setLoadingButton({ loading: false, id });
        console.log(err);
      });
  };

  return (
    <>
      {error ? <h1>error</h1> : " "}
      <Paper
        elevation={3}
        sx={{ p: 3, height: "70vh", display: "flex", flexDirection: "column" }}
      >
        <Box sx={{ mb: 5 }}>
          <FormControl fullWidth variant="outlined">
            <InputLabel htmlFor="password">Pesquisar</InputLabel>
            <OutlinedInput
              onChange={(ev) => onSearch(ev.target.value)}
              type="text"
              endAdornment={
                <InputAdornment position="end">
                  <SearchIcon />
                </InputAdornment>
              }
              label="Pesquisar"
            />
          </FormControl>
        </Box>
        <Box mb={5} display="flex" sx={{ mr: 2 }} justifyContent="flex-end">
         {/*  <Button variant="contained" endIcon={<AddIcon />}>
           Novo Usuário
          </Button> */}
        </Box>

        <TableUsers
          loadingButton={loadingButton}
          handleStatus={handleStatus}
          isUserPage={true}
          users={users}
          loading={loading}
        />
      </Paper>
    </>
  );
}
